import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { useUser } from "../../context/UserContext";
import Navbar from './../../components/common/Navbar';
import MobileNavbar from "../../components/common/MobileNavbar";
import FooterUser from "../../components/common/FooterUser";

const SIDEBAR_WIDTH = 240;

const navItems = [

  {
    path: "/dashboard-user",
    label: "Dashboard",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    path: "/profile",
    label: "Profile",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    path: "/addresses",
    label: "addresses",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },

  {
    path: "/my-referral",
    label: "My Referral",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" strokeLinecap="round" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    path: "/my-team",
    label: "My Team",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <circle cx="9" cy="7" r="3" />
        <path d="M3 20c0-3 2.7-5 6-5s6 2 6 5" strokeLinecap="round" />
        <circle cx="17" cy="7" r="3" />
        <path d="M21 20c0-3-2-5-4-5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    path: "/level-income",
    label: "Level",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" strokeLinecap="round" strokeLinejoin="round" />
        <polyline points="16 7 22 7 22 13" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: "/user-rank",
    label: "User Rank",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: "/deposit-history",
    label: "Deposit",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: "/transfer",
    label: "Transfer",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M17 10l4-4m0 0l-4-4m4 4H7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 14l-4 4m0 0l4 4m-4-4h14" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: "/transaction",
    label: "Transaction",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M3 10h18M3 10l9-7 9 7M3 10v10a1 1 0 001 1h16a1 1 0 001-1V10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 21V12h6v9" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: "/password-settings",
    label: "Password Settings",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];
export default function DashboardLayout() {
  const { isDarkMode } = useTheme();
  const { logout } = useUser();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const NAVBAR_HEIGHT = 60; // apne Navbar ki actual height set karo

  const C = {
    pageBg: isDarkMode ? "#12110e" : "rgb(245, 241, 232)",
    sidebarBg: isDarkMode ? "#1a1814" : "#ffffff",
    headerBg: isDarkMode ? "#1a1814" : "#ffffff",
    border: isDarkMode ? "rgba(212,175,55,.14)" : "rgba(180,155,100,.22)",
    textPrimary: isDarkMode ? "#f0ece2" : "#2c2416",
    textSecondary: isDarkMode ? "#7a7060" : "#9c8c70",
    activeColor: isDarkMode ? "#d4af37" : "#b8882a",
    activeBg: isDarkMode ? "rgba(212,175,55,.14)" : "rgba(184,136,42,.10)",
    hoverBg: isDarkMode ? "rgba(255,255,255,.05)" : "rgba(180,155,100,.09)",
    dotColor: isDarkMode ? "#d4af37" : "#b8882a",
  };

  return (
    <>
      {/* Navbar — fixed top */}
      <div className="d-none d-lg-block" style={{
        position: "fixed",
        top: 0, left: 0, right: 0,
        zIndex: 200,
      }}>
        <Navbar />
      </div>
      <MobileNavbar />

      <div style={{
        display: "flex",
        minHeight: "100vh",
        background: C.pageBg,
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        color: C.textPrimary,
        paddingTop: NAVBAR_HEIGHT, // navbar ke neeche se start

      }}>


        {/* Mobile header */}
        <header
          className="dash-header"
          style={{
            height: 60,
            background: C.headerBg,
            borderBottom: `1px solid ${C.border}`,
            display: "none",
            alignItems: "center",
            padding: "0 16px",
            position: "fixed",
            top: NAVBAR_HEIGHT,
            left: 0, right: 0,
            zIndex: 100,
            boxShadow: isDarkMode
              ? "0 1px 12px rgba(0,0,0,.4)"
              : "0 1px 12px rgba(180,155,100,.10)",
          }}
        >
          <button
            onClick={() => setSidebarOpen(prev => !prev)}
            aria-label="Toggle sidebar"
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "none", border: "none", cursor: "pointer",
              padding: 6, borderRadius: 7, color: C.textPrimary, flexShrink: 0,
            }}
          >
            <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {sidebarOpen
                ? <path d="M18 6 6 18M6 6l12 12" strokeLinecap="round" />
                : <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />}
            </svg>
          </button>
        </header>

        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            onClick={() => setSidebarOpen(false)}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.42)", zIndex: 90 }}
          />
        )}

        {/* ── SIDEBAR — fixed, navbar ke neeche ── */}
        <aside
          className={`dash-sidebar${sidebarOpen ? " dash-sidebar--open" : ""}`}
          style={{
            width: SIDEBAR_WIDTH,
            background: C.sidebarBg,
            borderRight: `1px solid ${C.border}`,
            display: "flex",
            flexDirection: "column",
            position: "fixed",           // ← fixed
            top: NAVBAR_HEIGHT,          // ← navbar ke bilkul neeche
            left: 0,
            bottom: 0,                   // ← poora height cover kare
            height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,  // ← explicit height
            zIndex: 95,
            transition: "transform 0.26s cubic-bezier(.4,0,.2,1)",
            boxShadow: isDarkMode ? "none" : "2px 0 16px rgba(180,155,100,.08)",
            marginTop: sidebarOpen ? 0 : "21px",   // ← yeh add karo
            overflow: "hidden"           // ← prevent overall overflow

          }}
        >
          {/* Mobile sidebar header */}
          <div
            className="dash-sidebar-header"
            style={{
              display: "none",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 16px 10px",
              borderBottom: `1px solid ${C.border}`,
            }}
          >
            <span style={{ fontWeight: 700, fontSize: 14, color: C.activeColor }}>Menu</span>
            <button
              onClick={() => setSidebarOpen(false)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: C.textSecondary }}
            >
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M18 6 6 18M6 6l12 12" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          {/* Gold accent bar */}
          <div style={{
            height: 3, flexShrink: 0,
            background: isDarkMode
              ? "linear-gradient(90deg,#d4af37,#f0c842,transparent)"
              : "linear-gradient(90deg,#b8882a,#d4a843,transparent)",
          }} />

          {/* Nav links - scrollable area */}
          <div style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            padding: "12px 10px",
            minHeight: 0
          }}>
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setSidebarOpen(false)}
                style={({ isActive }) => ({
                  display: "flex", alignItems: "center", gap: 11,
                  padding: "10px 13px", borderRadius: 10, marginBottom: 3,
                  textDecoration: "none", fontSize: 13.5,
                  fontWeight: isActive ? 700 : 400,
                  color: isActive ? C.activeColor : C.textPrimary,
                  background: isActive ? C.activeBg : "transparent",
                  borderLeft: isActive ? `3px solid ${C.activeColor}` : "3px solid transparent",
                  transition: "all 0.15s ease",
                })}
                onMouseEnter={e => {
                  if (!e.currentTarget.getAttribute("aria-current"))
                    e.currentTarget.style.background = C.hoverBg;
                }}
                onMouseLeave={e => {
                  if (!e.currentTarget.getAttribute("aria-current"))
                    e.currentTarget.style.background = "transparent";
                }}
              >
                {({ isActive }) => (
                  <>
                    <span style={{ color: isActive ? C.activeColor : C.textSecondary, flexShrink: 0, display: "flex" }}>
                      {item.icon}
                    </span>
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {isActive && (
                      <span style={{
                        width: 6, height: 6, borderRadius: "50%",
                        background: C.dotColor, flexShrink: 0,
                        boxShadow: `0 0 6px ${C.dotColor}`,
                      }} />
                    )}
                  </>
                )}
              </NavLink>
            ))}

            {/* Divider line */}
            <div style={{
              height: "1px",
              background: C.border,
              margin: "8px 0",
            }} />

            {/* Logout Button - Right after Password Settings */}
            <button
              onClick={() => {
                setSidebarOpen(false);
                logout();
              }}
              style={{
                display: "flex", alignItems: "center", gap: 11,
                padding: "10px 13px", borderRadius: 10,
                width: "100%",
                fontSize: 13.5,
                fontWeight: 400,
                color: "#ef4444",
                background: "transparent",
                border: "none",
                borderLeft: "3px solid transparent",
                transition: "all 0.15s ease",
                cursor: "pointer",
                textAlign: "left",
                marginBottom: 3,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = "rgba(239, 68, 68, 0.1)";
                e.currentTarget.style.borderLeft = "3px solid #ef4444";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.borderLeft = "3px solid transparent";
              }}
            >
              <span style={{ flexShrink: 0, display: "flex", color: "#ef4444" }}>
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="16 17 21 12 16 7" strokeLinecap="round" strokeLinejoin="round" />
                  <line x1="21" y1="12" x2="9" y2="12" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span style={{ flex: 1 }}>Logout</span>
            </button>
          </div>
        </aside>

        {/* ── MAIN CONTENT — sidebar ki width ka margin ── */}
        <main
          className="dash-main"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            background: C.pageBg,
            marginLeft: isMobile ? 0 : SIDEBAR_WIDTH,
          }}
        >
          <div
            className="ua-container-padding"
            style={{
              flex: 1,
              paddingBottom: isMobile ? "80px" : "130px",  // ← ab override nahi hoga
            }}
          >
            <Outlet />
          </div>

          {!isMobile && (
            <div
              style={{
                position: "fixed",
                bottom: 0,
                left: SIDEBAR_WIDTH,
                right: 0,
                zIndex: 10,
              }}
            >
              <FooterUser />
            </div>
          )}
        </main>
      </div>
      <style>{`
  @media (max-width: 768px) {
    .dash-header         { display: flex !important; }
    .dash-sidebar-header { display: flex !important; }
    .dash-sidebar {
      top: ${NAVBAR_HEIGHT}px !important;
      transform: translateX(-100%);
      display: flex !important;
      flex-direction: column !important;
    }
    .dash-sidebar--open {
      transform: translateX(0) !important;
      box-shadow: 4px 0 32px rgba(0,0,0,.22) !important;
    }
    .dash-main {
      margin-left: 0 !important;
    }
  }
  @media (min-width: 769px) {
    .dash-sidebar {
      transform: translateX(0) !important;
      display: flex !important;
      flex-direction: column !important;
    }
  }
  /* Custom scrollbar for nav items */
  .dash-sidebar > div:nth-last-child(2)::-webkit-scrollbar { width: 4px; }
  .dash-sidebar > div:nth-last-child(2)::-webkit-scrollbar-track { background: transparent; }
  .dash-sidebar > div:nth-last-child(2)::-webkit-scrollbar-thumb {
    background: rgba(180,155,100,.25);
    border-radius: 4px;
  }
  /* Ensure logout button area never scrolls */
  .dash-sidebar > div:last-child {
    position: relative !important;
    z-index: 10 !important;
  }
`}</style>
    </>
  );
}